export default __webpack_public_path__ + "static/media/generic.23542322.svg";